import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faFighterJet } from "@fortawesome/free-solid-svg-icons";
import { setAuthentication } from 'app/actions/commons';
import { useDispatch, useSelector } from 'react-redux';
import useScreenWidth from 'app/hooks/useScreenWidth';
import Image from 'app/components/layouts/Image';
import { AppStoreState } from 'app/redux/store';
import { useTranslation } from 'next-i18next';
import * as authApi from 'app/requests/auth';
import { useRouter } from 'next/router';
import { User } from 'types/auth';
import { useState } from 'react';

const UserDropdown = () => {
  const { auth } = useSelector((state: AppStoreState) => state.global);
  const [visibleMenu, setVisibleMenu] = useState(true);
  const screenWidth = useScreenWidth();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const router = useRouter()

  const handleLogout = async () => {
    await authApi.logoutSystem()
    document.cookie = 'auth_token=; path=/; max-age=0';
    dispatch(setAuthentication({} as User));
    router.push("/auth/login");
    setVisibleMenu(false)
  }

  const handleLogin = () => {
    if (router.asPath !== "/auth/login") {
      router.push("/auth/login");
    }
    setVisibleMenu(false)
  }

  const handleChangePassword = () => {
    if (router.asPath !== "/auth/change") {
      router.push("/auth/change");
    }
    setVisibleMenu(false)
  }

  const edit = () => {
    if (router.asPath !== "/auth/edit") {
      router.push("/auth/edit");
    }
    setVisibleMenu(false)
  }

  const info = () => {
    if (router.asPath !== "/auth/info") {
      router.push("/auth/info");
    }
    setVisibleMenu(false)
  }

  const dropdownMenu = () => {
    return [
      {
        image: "/images/auth/info_user.webp",
        description: 'info_user',
        isShow: auth.name,
        name: auth.name,
        click: info,
      },
      {
        image: "/images/auth/edit_user.webp",
        name: t('auth.edit_user'),
        isShow: auth.name,
        click: edit,
      },
      {
        image: "/images/auth/login.webp",
        name: t('auth.login'),
        isShow: !auth.name,
        click: handleLogin,
      },
      {
        image: "/images/auth/reset_password.webp",
        isShow: auth.name && !auth.is_social,
        name: t('auth.change_password'),
        click: handleChangePassword,
      },
      {
        image: "/images/auth/logout.webp",
        name: t('auth.logout'),
        click: handleLogout,
        isShow: auth.name,
      }
    ]
      .filter(item => item.isShow)
      .map((item: any, index: number) => {
        return (
          <li key={index} className="item-menu item-auth" onClick={() => item.click()}>
            <span className="nav-link p-2 item-auth text-white font-weight-bold text-size-md d-flex">
              <Image
                width={30}
                height={30}
                disableAuto
                className="mr-3"
                alt={item.name}
                src={item.image}
              />
              <div className="d-inline route-name">
                {item.name}
                {item.description &&
                  <div className='description d-block'>
                    {t(`routes.${item.description}`)}
                  </div>
                }
              </div>
              <div className="box-icon-redirect">
                <FontAwesomeIcon className="icon-redirect" icon={faFighterJet} />
              </div>
            </span>
          </li>
        )
      })
  }

  return (
    <span className='position-relative item-menu'>
      <Image
        id="icon-login"
        alt="image login"
        width={40}
        height={40}
        disableAuto
        className="my-2 border rounded-circle cursor-pointer"
        onClick={() => setVisibleMenu(true)}
        src={auth?.avatar || '/images/auth/login2.webp'}
      />
      {(visibleMenu || screenWidth > 1100) &&
        <ul className="dropdown-menu dropdown-menu-user mt-0" style={{ top: 40 }}>
          {dropdownMenu()}
        </ul>
      }
      <style jsx>{`
        @media (max-width: 1200px) {
          .dropdown-menu-user {
            right: -40px;
          }
        }
      `}
      </style>
    </span>
  )
}

export default UserDropdown;
